import { UseTypedQueryOptions } from "api/UseTypedQueryOptions";
import { UseQueryResult, useQuery } from "react-query";

import { ServiceReadDTO } from "../__generated__/CatalogueAPI";
import { getCatalogue } from "../catalogApi";

export type LegacyServiceReadDTO = Omit<ServiceReadDTO, "lifeCycles" | "industries" | "valueChains"> & {
  lifeCycles: string[];
  industries: string[];
  valueChains: string[];
  lifeCyclesList: ServiceReadDTO["lifeCycles"];
  industriesList: ServiceReadDTO["industries"];
  valueChainsList: ServiceReadDTO["valueChains"];
};

export default function useLiveService(
  props?: UseTypedQueryOptions<LegacyServiceReadDTO[]>
): UseQueryResult<LegacyServiceReadDTO[]> {
  return useQuery(
    "service/live",
    () =>
      getCatalogue().then((res) => {
        return res.map((s) => ({
          ...s,
          lifeCyclesList: s.lifeCycles,
          lifeCycles: (s.lifeCycles || []).map((l) => l.name || "").filter(Boolean),
          industriesList: s.industries,
          industries: (s.industries || []).map((i) => i.name || "").filter(Boolean),
          valueChainsList: s.valueChains,
          valueChains: (s.valueChains || []).map((v) => v.name || "").filter(Boolean),
        }));
      }),
    props
  );
}
